// extracted by mini-css-extract-plugin
export default {"readMore":"WKb8cH4H","mobile":"mobile","title":"h_9tnxIz","desktop":"desktop"};